import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import { Spin, Modal, Tag } from "antd";
import Bridge from "../constants/Bridge";
import moment from "moment";
import Strings from "../constants/Strings";
import AlsStudyAbastract from "./AlsStudyAbastract";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import $ from "jquery";
const ContentLibrary = () => {
  const [contentList, setContentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewDescModalStatus, setViewDescModalStatus] = useState(false);
  const [videoModalStatus, setVideoModalStatus] = useState(false);
  const [desc, setDesc] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
  const [chatbotModalStatus, setChatbotModalStatus] = useState(false);
  const [chatbotUrl, setchatbotUrl] = useState("");
  const [title, setTitle] = useState("");
  const [pageFrom, setPageFrom] = useState(0);
  const [pageTo, setPageTo] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  // on load component function
  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    getContentData(0);
  }, [0]);
  // get dashboard counts
  const getContentData = (pageNo) => {
    setLoading(true);
    let params = "?page=" + pageNo;
    Bridge.content_library
      .list(params)
      .then((response) => {
        if ((response.status = "1")) {
          setContentList(response.data);
          let no_of_pages = parseFloat(response.total) / 30;
          let total_pages = Math.ceil(no_of_pages);
          setTotalPage(total_pages);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    // view audit log
    Bridge.audit_logs.view_content_library_page();
  };
  const closeViewDescModal = () => {
    setViewDescModalStatus(false);
  };
  const viewDescModal = (item) => {
    setViewDescModalStatus(true);
    setDesc(item.description);
    setTitle(item.title);
    let params = "?title=" + item.title;
    Bridge.audit_logs.view_content_library_full_description(params);
  };
  const closeVideoModal = () => {
    setVideoModalStatus(false);
    setTitle("");
    setYoutubeLink("");
    stopVideo();
    //  document.getElementById('youtube-iframe').stopVideo();
  };
  const stopVideo = () => {
    var iframe = document.getElementById("youtube-iframe");
    var iframeSrc = iframe.src;

    // Check if the iframe source contains the YouTube video domain
    if (iframeSrc && iframeSrc.indexOf("youtube.com/embed/") !== -1) {
      // Replace 'autoplay=1' with 'autoplay=0' to stop the video
      var newSrc = iframeSrc.replace("autoplay=1", "autoplay=0");
      iframe.src = newSrc;
    }
  };
  const showVideoModal = (item) => {
    setVideoModalStatus(true);
    setTitle(item.title);
    setYoutubeLink(item.youtube_link);
    let params = "?title=" + item.title;
    Bridge.audit_logs.view_content_library_record_details(params);
  };
  const openChatbotModal = (item) => {
    setChatbotModalStatus(true);
    setTitle(item.title);
    setchatbotUrl(item.chatbot_url);
    let params = "?title=" + item.title;
    Bridge.audit_logs.view_content_library_chatbot(params);
  };
  const closeChatbotModal = () => {
    setChatbotModalStatus(false);
    setTitle("");
    setchatbotUrl("");
  };
  
  const openExpertAIChatbot = () => {
    setChatbotModalStatus(true);
    setTitle("Expert Talk AI");
    // Use the same chatbot URL as the first content item, or a default Expert AI URL
    const expertAIUrl = contentList && contentList.length > 0 
      ? contentList[0].chatbot_url 
      : "https://chatbot.example.com/expert-ai"; // Replace with actual Expert AI chatbot URL
    setchatbotUrl(expertAIUrl);
    let params = "?title=Expert Talk AI";
    Bridge.audit_logs.view_content_library_chatbot(params);
  };
  const show_page = (page) => {
    let page_num = Number(page - 1);
    let page_to = Number(page_num * 30);
    setLoading(true);
    setPageTo(page_to);
    setCurrentPage(page);
    setTimeout(() => {
      getContentData(page_to);
    }, 2000);
  };
  return (
    <div className="content-library-page">
      <div>
        <Header />
        <div className="row">
          <Sidebar />
          <div
            className="col-lg-10 main_content_right_side"
            style={{
              minHeight: "100vh",
              paddingLeft: "32px",
              paddingRight: "30px",
              marginLeft: "auto",
              backgroundColor: "#F5F5F5",
            }}
          >
            <Spin spinning={loading}>
              <div className="main-section">
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
                    <p
                      style={{
                        position: "relative",
                        fontSize: 32,
                        fontFamily: "Open Sans",
                        fontWeight: "bold",
                        color: "#1A4F83",
                        textAlign: "start",
                        margin: 0,
                      }}
                    >
                      {Strings.contentLibrary}
                    </p>
                    <button
                      className="btn btn-lg"
                      style={{
                        backgroundColor: "#1A4F83",
                        borderColor: "#1A4F83",
                        fontWeight: "bold",
                        fontSize: "16px",
                        padding: "12px 24px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(26, 79, 131, 0.3)",
                        color: "white",
                        border: "1px solid #1A4F83",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#0f3a6b";
                        e.target.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#1A4F83";
                        e.target.style.color = "white";
                      }}
                      onClick={() => openExpertAIChatbot()}
                    >
                      <i className="fas fa-robot me-2" style={{color: "white"}}></i>
                      Chat with Expert Talk AI
                    </button>
                  </div>
                  <AlsStudyAbastract />
                  <div className="d-flex justify-content-end mb-3">
                   
                  </div>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 20,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "left",
                    }}
                    className="mb-4"
                  >
                    ALS EXPERT TALK SERIES
                  </p>
                  <Spin spinning={loading}>
                    <div className="content-library-list-wrapper">
                      <div className="row">
                        {contentList &&
                          contentList.map((item, index) => {
                            let title = item.title.substring(0, 40) + "...";
                            let date_created = item.publish_date.split("T")[0];
                            date_created =
                              moment(date_created).format("MM/DD/YYYY");
                            return (
                              <div className="col-lg-4">
                                <div className="single-content">
                                  <h3 style={{ minHeight: 113 }}>
                                    {item.title.length > 40
                                      ? title
                                      : item.title}
                                  </h3>
                                  <div className="desc">
                                    <p
                                      style={{
                                        maxHeight: 50,
                                        minHeight: 50,
                                        overflow: "hidden",
                                      }}
                                    >
                                      {item.description.substring(0, 80)}
                                    </p>
                                    <div className="d-flex justify-content-between">
                                      {item.description.length > 80 && (
                                        <a
                                          href="#"
                                          onClick={() => viewDescModal(item)}
                                        >
                                          Read more..
                                        </a>
                                      )}
                                      <div>
                                        <i
                                          onClick={() => openChatbotModal(item)}
                                          className="fab fa-rocketchat"
                                          style={{
                                            position: "relative",
                                            right: 9,
                                            fontSize: 22,
                                            top: 3,
                                            cursor: "pointer",
                                          }}
                                        ></i>
                                        <Tag
                                          color="blue"
                                          style={{ fontSize: 13 }}
                                        >
                                          {date_created}
                                        </Tag>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    onClick={() => showVideoModal(item)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <iframe
                                      style={{ pointerEvents: "none" }}
                                      width="100%"
                                      height={170}
                                      src={item.youtube_link}
                                      title="YouTube video player"
                                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                      allowFullScreen
                                    ></iframe>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                      <div className="pagination_list">
                        <ResponsivePagination
                          current={currentPage}
                          total={totalPage}
                          onPageChange={(page) => show_page(page)}
                        />
                      </div>
                    </div>
                  </Spin>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
      {/* Start Description Modal */}
      <Modal
        title={<h5>{title}</h5>}
        visible={viewDescModalStatus}
        onOk={() => closeViewDescModal()}
        onCancel={() => closeViewDescModal()}
        okText="Ok"
        cancelText="Cancel"
        width={600}
      >
        <div style={{ fontSize: 17, padding: 15 }}>{desc}</div>
      </Modal>
      {/* Start Youtube Url Modal */}
      <Modal
        title={<h5>{title}</h5>}
        visible={videoModalStatus}
        onOk={() => closeVideoModal()}
        onCancel={() => closeVideoModal()}
        okText="Ok"
        cancelText="Cancel"
        width={650}
      >
        <div style={{ fontSize: 17, padding: 15 }}>
          <iframe
            width="100%"
            height={360}
            id="youtube-iframe"
            src={youtubeLink}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </Modal>
      {/* Start Chatbot Url Modal */}
      <Modal
        title={<h5>{title}</h5>}
        visible={chatbotModalStatus}
        onOk={() => closeChatbotModal()}
        onCancel={() => closeChatbotModal()}
        okText="Ok"
        cancelText="Cancel"
        width={900}
        className="chatbot-modal"
      >
        <div style={{ fontSize: 17, padding: 15 }}>
          <iframe
            width="100%"
            height={500}
            src={chatbotUrl}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </Modal>
    </div>
  );
};

export default ContentLibrary;
